import $ from "jquery";
import "jquery-match-height";

const whatsInsideTitle = $('.js-whats-inside-title');
const whatsInsideDescription = $('.js-whats-inside-description');

$(window).on('load', function(){
  setTimeout(function(){
      whatsInsideTitle.matchHeight();
      whatsInsideDescription.matchHeight();    
  }, 500);
});

$(window).on('resize', function(){
    setTimeout(function(){
        whatsInsideTitle.matchHeight();
        whatsInsideDescription.matchHeight();        
    }, 500);
});

$(window).on('orientationchange', function() {
    setTimeout(function(){
        whatsInsideTitle.matchHeight();
        whatsInsideDescription.matchHeight();
    }, 500);
});